import BasicProfilePresenter from "@adapters/features/BasicProfile/Presenters/BasicProfile";
export default (useCases, actions) => {
    return {
        basicProfile: new BasicProfilePresenter(useCases.basicProfile, actions.basicProfile),
    };
};
